import axiosVerbose from '../../utils/axios/axiosVerbose'

import {
  logError,
  ResponseDataError
} from '../../utils/errors'

const fetchRecommendedSearchesByTermResults = (term, { apiUrlPrefix }) => {
  return (dispatch) => {
    const url = `${apiUrlPrefix}/shopfront_api/recommendation/${encodeURIComponent(term)}`
    dispatch({
      type: 'fetchRecommendedSearchesByTermResultsRequest'
    })

    return axiosVerbose.get(url, { timeout: 5000 }).then((res) => {
      if (res.data && res.data.relatedSearches && !res.data.error) {
        return dispatch({
          type: 'fetchRecommendedSearchesByTermResultsSuccess',
          payload: {
            recommendations: res.data.relatedSearches,
            hint: term
          }
        })
      } else {
        throw ResponseDataError({response: res})
      }
    })
    .catch(err => Promise.reject(logError(err)))
    .catch((err) => {
      return dispatch(fetchRecommendedSearchesByTermResultsFailure(err))
    })
  }
}

const fetchRecommendedSearchesByTermResultsFailure = () => {
  return (dispatch) => {
    dispatch({
      type: 'fetchRecommendedSearchesByTermResultsFailure',
      error: true
    })
  }
}

export default fetchRecommendedSearchesByTermResults



// WEBPACK FOOTER //
// ./common/actions/search/fetchRecommendedSearchesByTermResults.js